const preSurveyQuestionsImagine = [
  {
    question:
      "How strongly do you agree with the statement: “It is difficult to create accessible software”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I find planning for accessible software difficult”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I frequently think about accessibility when designing software”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I look for accessibility features when I get a new app”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
  {
    question:
      "How strongly do you agree with the statement: “I consider accessibility as a top priority when designing software”?",
    answers: [
      {
        index: "0",
        content: "Strongly disagree",
      },
      {
        index: "1",
        content: "Disagree",
      },
      {
        index: "2",
        content: "Neutral",
      },
      {
        index: "3",
        content: "Agree",
      },
      {
        index: "4",
        content: "Strongly agree",
      },
    ],
    type: "singleChoice",
  },
];

export default preSurveyQuestionsImagine;
